(function () {
  'use strict';

  var STORAGE_KEY = 'pvl_enquiry_list_v1';

  function readItems() {
    try {
      var raw = window.localStorage.getItem(STORAGE_KEY);
      var items = raw ? JSON.parse(raw) : [];
      return Array.isArray(items) ? items : [];
    } catch (error) {
      return [];
    }
  }

  function writeItems(items) {
    try {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
    } catch (error) {}
    updateCounts(items);
    updateHiddenEnquiry(items);
  }

  function itemCount(items) {
    return items.reduce(function (total, item) {
      return total + Math.max(1, parseInt(item.quantity, 10) || 1);
    }, 0);
  }

  function updateCounts(items) {
    var count = itemCount(items || readItems());
    document.querySelectorAll('[data-pvl-enquiry-count]').forEach(function (element) {
      element.textContent = count;
      element.hidden = count === 0;
      element.setAttribute('aria-label', count + (count === 1 ? ' item in enquiry list' : ' items in enquiry list'));
    });
  }

  function currentVariantForButton(button) {
    var form = button.closest('form');
    var idInput = form ? form.querySelector('input[name="id"]') : null;

    return {
      id: idInput && idInput.value ? idInput.value : button.dataset.variantId,
      sku: button.dataset.variantSku || (idInput && idInput.dataset.sku ? idInput.dataset.sku : ''),
      title: button.dataset.variantTitle || 'Default'
    };
  }

  function addFromButton(button) {
    var variant = currentVariantForButton(button);
    var items = readItems();
    var key = String(variant.id || button.dataset.productId);
    var existing = items.find(function (item) { return String(item.key) === key; });

    if (existing) {
      existing.quantity = Math.max(1, parseInt(existing.quantity, 10) || 1) + 1;
    } else {
      items.push({
        key: key,
        productId: button.dataset.productId || '',
        productTitle: button.dataset.productTitle || '',
        productHandle: button.dataset.productHandle || '',
        productUrl: button.dataset.productUrl || '',
        vendor: button.dataset.productVendor || '',
        image: button.dataset.productImage || '',
        variantId: variant.id || '',
        variantTitle: variant.title || '',
        sku: variant.sku || '',
        quantity: 1
      });
    }

    writeItems(items);

    var status = button.parentElement ? button.parentElement.querySelector('[data-pvl-enquiry-status]') : null;
    if (status) {
      status.innerHTML = 'Added. <a href="/cart">View enquiry list</a>';
      window.setTimeout(function () { status.innerHTML = ''; }, 5000);
    }
  }

  function productUrl(item) {
    var url = item.productUrl || '#';
    if (item.variantId && url !== '#') {
      url += (url.indexOf('?') === -1 ? '?' : '&') + 'variant=' + encodeURIComponent(item.variantId);
    }
    return url;
  }

  function makeText(tag, className, text) {
    var element = document.createElement(tag);
    if (className) element.className = className;
    element.textContent = text || '';
    return element;
  }

  function renderList() {
    var root = document.querySelector('[data-pvl-enquiry-list]');
    if (!root) return;

    var items = readItems();
    root.innerHTML = '';

    var empty = document.querySelector('[data-pvl-enquiry-empty]');
    var formWrap = document.querySelector('[data-pvl-enquiry-form-wrap]');

    if (items.length === 0) {
      if (empty) empty.hidden = false;
      if (formWrap) formWrap.hidden = true;
      updateHiddenEnquiry(items);
      return;
    }

    if (empty) empty.hidden = true;
    if (formWrap) formWrap.hidden = false;

    items.forEach(function (item) {
      var row = document.createElement('div');
      row.className = 'pvl-enquiry-item';
      row.dataset.key = item.key;

      var media = document.createElement('div');
      media.className = 'pvl-enquiry-item__media';
      if (item.image) {
        var image = document.createElement('img');
        image.src = item.image;
        image.alt = '';
        image.loading = 'lazy';
        media.appendChild(image);
      }

      var info = document.createElement('div');
      info.className = 'pvl-enquiry-item__info';
      var title = document.createElement('a');
      title.className = 'pvl-enquiry-item__title text--strong link';
      title.href = productUrl(item);
      title.textContent = item.productTitle;
      info.appendChild(title);

      var metaParts = [];
      if (item.vendor) metaParts.push(item.vendor);
      if (item.variantTitle && item.variantTitle !== 'Default Title' && item.variantTitle !== 'Default') metaParts.push(item.variantTitle);
      if (item.sku) metaParts.push('SKU: ' + item.sku);
      if (metaParts.length) info.appendChild(makeText('div', 'pvl-enquiry-item__meta text--small', metaParts.join(' · ')));

      var controls = document.createElement('div');
      controls.className = 'pvl-enquiry-item__controls';
      var label = makeText('label', 'text--small text--strong', 'Quantity');
      var input = document.createElement('input');
      input.type = 'number';
      input.min = '1';
      input.step = '1';
      input.value = Math.max(1, parseInt(item.quantity, 10) || 1);
      input.className = 'pvl-enquiry-qty';
      input.setAttribute('aria-label', 'Quantity for ' + item.productTitle);
      input.addEventListener('change', function () {
        var next = readItems();
        var match = next.find(function (candidate) { return String(candidate.key) === String(item.key); });
        if (match) match.quantity = Math.max(1, parseInt(input.value, 10) || 1);
        input.value = match ? match.quantity : 1;
        writeItems(next);
      });
      label.appendChild(input);
      controls.appendChild(label);

      var remove = document.createElement('button');
      remove.type = 'button';
      remove.className = 'link link--accented pvl-enquiry-remove';
      remove.textContent = 'Remove';
      remove.addEventListener('click', function () {
        var next = readItems().filter(function (candidate) { return String(candidate.key) !== String(item.key); });
        writeItems(next);
        renderList();
      });
      controls.appendChild(remove);

      row.appendChild(media);
      row.appendChild(info);
      row.appendChild(controls);
      root.appendChild(row);
    });

    updateHiddenEnquiry(items);
  }

  function enquiryText(items) {
    if (!items.length) return '';
    var lines = ['PVL PRODUCT ENQUIRY', ''];
    items.forEach(function (item, index) {
      var absoluteUrl = item.productUrl || '';
      if (absoluteUrl && absoluteUrl.charAt(0) === '/') absoluteUrl = window.location.origin + absoluteUrl;
      if (item.variantId && absoluteUrl) absoluteUrl += (absoluteUrl.indexOf('?') === -1 ? '?' : '&') + 'variant=' + item.variantId;

      lines.push((index + 1) + '. ' + item.productTitle);
      if (item.vendor) lines.push('Manufacturer / vendor: ' + item.vendor);
      if (item.variantTitle && item.variantTitle !== 'Default Title' && item.variantTitle !== 'Default') lines.push('Variant: ' + item.variantTitle);
      if (item.sku) lines.push('SKU: ' + item.sku);
      lines.push('Quantity: ' + Math.max(1, parseInt(item.quantity, 10) || 1));
      if (absoluteUrl) lines.push('Product: ' + absoluteUrl);
      lines.push('');
    });
    return lines.join('\n');
  }

  function updateHiddenEnquiry(items) {
    var field = document.querySelector('[data-pvl-enquiry-field]');
    if (field) field.value = enquiryText(items || readItems());
  }

  function handleSentState() {
    var params = new URLSearchParams(window.location.search);
    if (params.get('enquiry') !== 'sent') return false;

    writeItems([]);
    var success = document.querySelector('[data-pvl-enquiry-success]');
    if (success) success.hidden = false;
    var empty = document.querySelector('[data-pvl-enquiry-empty]');
    if (empty) empty.hidden = true;
    var formWrap = document.querySelector('[data-pvl-enquiry-form-wrap]');
    if (formWrap) formWrap.hidden = true;
    var root = document.querySelector('[data-pvl-enquiry-list]');
    if (root) root.innerHTML = '';
    return true;
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-pvl-add-enquiry]');
    if (!button) return;
    event.preventDefault();
    addFromButton(button);
  });

  document.addEventListener('variant:changed', function (event) {
    var variant = event.detail && event.detail.variant;
    if (!variant || !(event.target instanceof Element)) return;
    event.target.querySelectorAll('[data-pvl-add-enquiry]').forEach(function (button) {
      button.dataset.variantId = variant.id || '';
      button.dataset.variantTitle = variant.title || '';
      button.dataset.variantSku = variant.sku || '';
    });
  });

  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!(form instanceof HTMLFormElement) || form.id !== 'pvl-enquiry-form') return;
    var items = readItems();
    if (!items.length) {
      event.preventDefault();
      renderList();
      return;
    }
    updateHiddenEnquiry(items);
  });

  document.addEventListener('DOMContentLoaded', function () {
    updateCounts();
    if (!handleSentState()) renderList();
  });
})();
